import { confirmation, notify } from '@app/ui';
import { useResetTwoFactorMethodMutation } from '@app/main/api';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserContextSelector } from './useUserContext';

export function useResetTwoFactorMethod() {
  const { t } = useTranslation();
  const id = useUserContextSelector((x) => x.id);
  const [reset] = useResetTwoFactorMethodMutation();

  return useCallback(() => {
    confirmation.show({
      title: t('users.twoFactorMethodReset.modal.title'),
      body: t('users.twoFactorMethodReset.modal.body'),
      onConfirm() {
        reset({ id })
          .unwrap()
          .then(() => notify.success.t('users.twoFactorMethodReset.success'));
      },
    });
  }, [reset, t, id]);
}
